import { render, staticRenderFns } from "./SubmittedCard.vue?vue&type=template&id=39b7e70b"
import script from "./SubmittedCard.vue?vue&type=script&lang=js"
export * from "./SubmittedCard.vue?vue&type=script&lang=js"
import style0 from "./SubmittedCard.vue?vue&type=style&index=0&id=39b7e70b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports